import logo from '../../assets/full-white-logo.webp';
import './LandingPage.css';
import { useNavigate } from 'react-router-dom';

const HeaderBar = ({ toggleModal }: { toggleModal: () => void }) => {
  const navigate = useNavigate();

  return (
    <div className='header-bar'>
      <img src={logo} alt='Practist Logo' className='landing-logo' />
      <div className='header-buttons'>
        <button
          onClick={() => navigate('/login')}
          className='outline-button'
          style={{
            cursor: 'pointer',
            position: 'relative',
            zIndex: 'var(--mantine-z-index-app)',
          }}
        >
          Sign In
        </button>
        <button onClick={toggleModal} className='primary-button'>
          Join Waitlist
        </button>
      </div>
    </div>
  );
};

export default HeaderBar;
